import { AmplifyTheme } from 'aws-amplify-react';

// The screen width values are from _variables.scss
const getMaxWidth = () => {
  switch (true) {
    case screen.width >= 1200:
      return '50%';
    case screen.width >= 992:
      return '75%';
    default:
      return '100%';
  }
};

export const Container = {
  backgroundColor: '#fff',
  maxWidth: getMaxWidth(),
  margin: '0 auto',
  padding: '7% 0',
  width: '630px'
};

export const TabContainer = {
  backgroundColor: '#fff',
  maxWidth: '100%',
  margin: '0 auto'
};

export const FormContainer = {
  textAlign: 'center'
};

export const FormSection = {
  // NOTE: setting this object to empty to remove default styling
};

export const SectionBody = {
  padding: '15px'
};

export const SectionHeader = {
  paddingTop: '1%',
  paddingBottom: '7%',
  fontSize: '20px'
};

export const TabSectionHeader = {
  display: 'none'
};

export const SectionHeaderContent = {
  fontSize: '27px',
  fontWeight: 'bold'
};

export const FormRow = {
  padding: '10px 0'
};

export const Input = {
  ...AmplifyTheme.input,
  fontSize: '16px'
};

export const Button = {
  width: '100%',
  height: '42px',
  backgroundColor: '#00838f',
  color: '#fff',
  borderRadius: '5px',
  fontSize: '16px',
  lineHeight: '20px',
  fontWeight: 'bold',
  marginTop: '30px'
};

export const SectionFooter = {
  // NOTE: setting this object to empty to remove default styling
  marginTop: '30px'
};

export const ErrorSectionContent = {
  margin: '15px',
  padding: '20px',
  backgroundColor: '#BC081C',
  color: '#fff',
  borderRadius: '5px',
  textAlign: 'center'
};

export const A = {
  fontSize: '14px',
  fontWeight: 'bold',
  color: '#0A5D69',
  cursor: 'pointer',
  textDecoration: 'underline'
};

export const MyPageTheme = Object.assign({}, AmplifyTheme, {
  container: Container,
  formContainer: FormContainer,
  formSection: FormSection,
  sectionHeader: SectionHeader,
  sectionHeaderContent: SectionHeaderContent,
  sectionBody: SectionBody,
  formRow: FormRow,
  input: Input,
  button: Button,
  sectionFooter: SectionFooter,
  errorSection: ErrorSectionContent,
  a: A
});

export const MyTabTheme = Object.assign({}, AmplifyTheme, {
  container: TabContainer,
  formContainer: FormContainer,
  formSection: FormSection,
  sectionHeader: TabSectionHeader,
  sectionHeaderContent: SectionHeaderContent,
  sectionBody: SectionBody,
  formRow: FormRow,
  input: Input,
  button: Button,
  sectionFooter: SectionFooter,
  errorSection: ErrorSectionContent,
  a: A
});



// WEBPACK FOOTER //
// ./src/amplifyTheme.js